module.exports = __webpack_public_path__ + "img/NP.aa4b7855.svg";